import './media-player.component.ajscss';

import { hasChange } from '@commons/util/helper/helper';
import { IChangesObject, IComponentController, IComponentOptions } from 'angular';

import { None, Option } from '@contact/upgrade';

import templateUrl from './media-player.component.ajs.html';
import { Audio, Playlist } from './models/audio';

class MediaPlayerCtrl implements IComponentController {
  public playingEvent: Function;
  public showEvent: Function;
  public currentAudioEvent: Function;
  public _playlist: Playlist = [];
  public _currentAudio: Audio | undefined = undefined;

  public audio: Option<NgAudioObject> = None;
  public isPlay: boolean = false;
  public isShow: boolean = false;

  public showPlaylist: boolean = false;
  public showAdvancedControls: boolean = false;

  public progress: number;

  constructor(public readonly ngAudio: NgAudio) {}

  $onChanges(onChangesObj: { [property: string]: IChangesObject }): void {
    if (hasChange(onChangesObj['playlist'])) {
      this._playlist = onChangesObj['playlist'].currentValue || [];
      if (this._playlist.length > 0) this.notifyShow(true);
    }
    if (hasChange(onChangesObj['currentAudio'])) {
      this.playSingleAudioFile(onChangesObj['currentAudio'].currentValue);
    }
  }

  getAudio(): NgAudioObject {
    return this.audio.getOrElse({} as NgAudioObject);
  }

  progressChange() {
    this.audio.forEach(audio => (audio.progress = this.progress));
  }

  playSingleAudioFile(currentAudio: Audio): void {
    Option.of(currentAudio).forEach(audio => {
      if (!!audio && !!audio.url) {
        this.reinitAudio(audio);
        this.notifyCurrentAudio(audio);
        this.notifyPlaying(true);
        this.notifyShow(true);
      }
    });
  }

  resetAudio() {
    this.audio.forEach(audio => {
      audio.stop();
      audio.unbind();
    });
  }

  reinitAudio(currentAudio: Audio) {
    this.resetAudio();
    var localAudio: NgAudioObject = this.ngAudio.load(currentAudio.url);
    // set volume value to 1 if not set (=undefined)
    localAudio.volume = localAudio.volume || 1;
    this.audio = Option.of(localAudio);
    this.audio.forEach(audio => audio.play());
  }

  play() {
    this.audio.forEach(audio => audio.play());
  }

  stop() {
    this.audio.forEach(audio => {
      audio.pause();
      audio.progress = 0;
      this.notifyPlaying(false);
    });
  }

  notifyCurrentAudio(audio: Audio | undefined) {
    this._currentAudio = audio;
    Option.of(this.currentAudioEvent).forEach(event => event({ $event: { audio } }));
  }

  notifyPlaying(active: boolean) {
    this.isPlay = active;
    Option.of(this.playingEvent).forEach(event => event({ $event: { active } }));
  }

  notifyShow(show: boolean) {
    this.isShow = show;
    if (!show) {
      this.resetAudio();
      this.notifyCurrentAudio(undefined);
    }
    Option.of(this.showEvent).forEach(event => event({ $event: { show } }));
  }
}

export class MediaPlayer implements IComponentOptions {
  templateUrl = templateUrl;
  bindings = {
    playlist: '<',
    currentAudio: '<',
    currentAudioEvent: '&',
    playingEvent: '&',
    showEvent: '&',
  };
  controller = ['ngAudio', MediaPlayerCtrl];
}

export default 'cngMediaplayer';
